import React from 'react'
import styled from 'styled-components'
import Arrow from '../../../../Arrow'

const Container = styled.div`
  padding-right: 25px;
  cursor: pointer;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    padding-right: 15px;
  }
`

export default ({ toggle, ...rest }) => (
  <Container onClick={toggle}>
    <Arrow {...rest} />
  </Container>
)
